import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationHeader() {

  /* ====================================
  # ヘッダー光の点エフェクト初期化
  ==================================== */
  const initHeaderLightAnimation = () => {
    const bgElements = [
      { element: document.querySelector('.l-header__bg01'), type: 'bg01' },
      { element: document.querySelector('.l-header__bg02'), type: 'bg02' }
    ];

    bgElements.forEach(({ element, type }) => {
      if (element) {
        addHeaderLightDots(element, type);
      }
    });
  };

  /* ====================================
  # ヘッダー光の点エフェクト
  ==================================== */
  const addHeaderLightDots = (container, bgType) => {
    const svgElement = container.querySelector('svg');
    if (!svgElement) return;

    // SVG内のpath要素を探す
    const pathElements = svgElement.querySelectorAll('path[stroke]') || svgElement.querySelectorAll('path');
    
    if (pathElements.length > 0) {
      createHeaderLightDot(pathElements[0], container, bgType);
    }
  };

  const createHeaderLightDot = (pathElement, container, bgType) => {
    // 光の点要素を作成
    const lightDot = document.createElement('div');
    lightDot.className = `header-light-dot header-light-dot--${bgType}`;

    // コンテナに追加
    container.appendChild(lightDot);

    // パスの長さを取得
    const pathLength = pathElement.getTotalLength();
    let currentDistance = 0;
    let isAnimating = false;

    // 移動設定
    const animationConfig = {
      speed: bgType === 'bg01' ? 5 : 3,
      direction: bgType === 'bg01' ? 1 : -1
    };

    // アニメーションループ
    const animateHeaderLightDot = () => {
      if (!isAnimating) return;
      
      // パス上の現在位置を取得
      const point = pathElement.getPointAtLength(currentDistance);
      const svgCTM = pathElement.getScreenCTM();
      
      if (svgCTM) {
        // SVGの変換行列を使って正確な画面座標を取得
        const screenPoint = point.matrixTransform(svgCTM);
        const containerRect = container.getBoundingClientRect();
        
        lightDot.style.left = (screenPoint.x - containerRect.left) + 'px';
        lightDot.style.top = (screenPoint.y - containerRect.top) + 'px';
      }

      // 次の位置に移動
      currentDistance += animationConfig.speed * animationConfig.direction;
      
      if (currentDistance > pathLength) {
        currentDistance = 0;
      } else if (currentDistance < 0) {
        currentDistance = pathLength;
      }

      requestAnimationFrame(animateHeaderLightDot);
    };

    // ページ読み込み後すぐにアニメーション開始（ヘッダーは常に表示されているため）
    const startAnimation = () => {
      if (!isAnimating) {
        isAnimating = true;
        animateHeaderLightDot();
      }
    };

    // モバイルメニューが開かれた時のみアニメーション開始
    const observeMenuOpen = () => {
      const mobileNav = document.querySelector('.l-header__nav--mobile');
      if (!mobileNav) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (mobileNav.classList.contains('is-active')) {
              startAnimation();
            } else {
              isAnimating = false;
            }
          }
        });
      });

      observer.observe(mobileNav, {
        attributes: true,
        attributeFilter: ['class']
      });
    };

    // 初期化
    observeMenuOpen();
  };

  // 初期化実行
  initHeaderLightAnimation();
} 